import React, { useRef, useEffect } from 'react';
import {Image} from "@project-stories/elements/Image/Image";
import './LogoStrip.scss';

export const LogoStrip = ({ settings }) => {
  const containerRef = useRef(null);
  const blocks = settings.blocks || [];
  const logos = blocks.filter((block) => block.type === 'logo');
  const animationSpeed = settings.animation_speed || 30;
  const filterStyle = {
    filter: 'brightness(0) saturate(100%)',
    background: 'transparent',
    opacity: settings.section.logo_opacity / 100 || 1,
    transition: 'opacity 0.3s ease',
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleMouseEnter = () => {
      container.style.animationPlayState = 'paused';
    };
    const handleMouseLeave = () => {
      container.style.animationPlayState = 'running';
    };
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);
  return (
    <div className="w-full overflow-hidden bg-transparent">
      <div ref={containerRef} className="flex items-center"
        style={{
          width: 'max-content',
          animation: `logo-strip-scroll ${animationSpeed}s linear infinite`,
        }}>
        {/* Render logos 4 times for smooth scrolling */}
        {Array.from({ length: 4 }, (_, setIndex) => (
          logos.map((block, index) => (
            <div className="flex items-center justify-center" key={`set-${setIndex}-logo-${index}`}>
              {
                block.settings.logo_image && (
                  <Image
                    imageUrl={block.settings.logo_image}
                    alt={`Logo ${index % blocks.length + 1}`}
                    style={{
                      ...filterStyle,
                    }}
                    classes={`
                      mx-[${settings.section.logo_spacing_mobile || 40}px]
                      h-[${settings.section.logo_height_mobile || 60}px]
                      lg:h-[${settings.section.logo_height || 60}px]
                      lg:mx-[${settings.section.logo_spacing || 60}px]`
                    }
                  />
                )
              }
            </div>
          ))
        )).flat()}
      </div>
    </div>
  );
};

export default LogoStrip;